import { CLEAR, ERROR, INITIALIZE, START, SUCCESS } from '../constants';

/**
 * Delete the the asynchronous request status(es) from state.
 * @param {Array} keyPaths one or more path(s) to prune
 * The routine can be given paths to specific requests or a request group
 * and all children will be pruned. For example, for a batch relationship delete
 * a key path might look like ['relationship', 'delete', relationShipId]. Calling this
 * routine with a keyPaths [['relationship', 'delete']] will delete all aysnc statuses
 * for any relationshipId.
 */
export const asyncClear = keyPaths => ({
	type: CLEAR,
	keyPaths,
});

/**
 * Indicate that an error occurred
 * @param {Array} keyPath unique path to the location in state
 * @param {Error} error
 */
export const asyncError = (keyPath, error) => ({
	type: ERROR,
	keyPath,
	error,
});

/**
 * Reset the state of the asynchronous request
 * @param {Array} keyPath unique path to the location in state
 */
export const asyncInitialize = keyPath => ({
	type: INITIALIZE,
	keyPath,
});

/**
 * Begin an asynchronous request
 * @param {Array} keyPath unique path to the location in state
 * @param {Axios token source} cancellationSource
 */
export const asyncStart = (keyPath, cancellationSource = null) => ({
	type: START,
	keyPath,
	cancellationSource,
});

/**
 * Indicate that the asynchronous request has completed
 * @param {Array} keyPath unique path to the location in state
 */
export const asyncSuccess = keyPath => ({
	type: SUCCESS,
	keyPath,
});
